import logUtil from 'utils/log'
import getPathWithoutQueryStringUtil from 'utils/string/get-path-without-query'

/**
 * @param props
 * @param {ProductVariantCollection} props.currentVariant
 * @param {ProductVariantCollection} props.selectedVariant
 */
const getSelectedMediaIndexFromSelectedVariantGiftSelectUtil = (props) => {
  const {
    currentVariant,
    selectedVariant
  } = props
  /**
   * @type {ProductVariantCollection.media}
   */
  const currentVariantMedia = currentVariant?.media || []
  const selectedVariantImageUrl = getPathWithoutQueryStringUtil(selectedVariant?.variant_image_url || selectedVariant?.image_url)
  const index = currentVariantMedia.findIndex(media => {
    return selectedVariantImageUrl === getPathWithoutQueryStringUtil(
      media?.preview?.image?.url ||
      media?.previewImage?.url
    )
  })

  const debugProps = {
    props,
    index
  }
  logUtil('getSelectedMediaIndexFromSelectedVariantGiftSelectUtil').debug('debugProps=', debugProps)

  return index
}

export default getSelectedMediaIndexFromSelectedVariantGiftSelectUtil
